import PortalVue from 'portal-vue'
import Guarantee from './Models/Guarantee'

Vue.prototype.$models.$guarantee = new Vue(Guarantee)

Vue.use(PortalVue)

Vue.component('guarantees-table', () => import(/* webpackChunkName: "guarantees-table" */ '@modulesPages/Site/Resources/assets/js/Tables/GuaranteesTable'))

Vue.component('guarantees-form', () => import(/* webpackChunkName: "guarantees-form" */ '@modulesPages/Site/Resources/assets/js/Forms/Guarantees/GuaranteesForm'))

Vue.component('card-guarantee1', () => import(/* webpackChunkName: "card-guarantee1" */ '@modulesPages/Site/Resources/assets/js/Cards/CardGuarantee1'))
Vue.component('card-guarantee2', () => import(/* webpackChunkName: "card-guarantee2" */ '@modulesPages/Site/Resources/assets/js/Cards/CardGuarantee2'))
Vue.component('gallery-card', () => import(/* webpackChunkName: "gallery-card" */ '@modulesPages/Site/Resources/assets/js/Cards/GalleryCard'))

Vue.component('banner-simple', () => import(/* webpackChunkName: "banner-simple" */ '@modulesPages/Site/Resources/assets/js/Components/BannerSimple'))
Vue.component('title-component1', () => import(/* webpackChunkName: "title-component1" */ '@modulesPages/Site/Resources/assets/js/Components/TitleComponent1'))
Vue.component('title-component2', () => import(/* webpackChunkName: "title-component2" */ '@modulesPages/Site/Resources/assets/js/Components/TitleComponent2'))
Vue.component('export-component', () => import(/* webpackChunkName: "export-component" */ '@modulesPages/Site/Resources/assets/js/Components/ExportComponent'))
Vue.component('product-import-component', () => import(/* webpackChunkName: "product-import-component" */ '@modulesPages/Site/Resources/assets/js/Components/ProductImportComponent'))
Vue.component('filter-posts', () => import(/* webpackChunkName: "filter-posts" */ '@modulesPages/Site/Resources/assets/js/Components/FilterPosts'))
Vue.component('filter-products', () => import(/* webpackChunkName: "filter-products" */ '@modulesPages/Site/Resources/assets/js/Components/FilterProducts'))
Vue.component('back-button', () => import(/* webpackChunkName: "back-button" */ '@modulesPages/Site/Resources/assets/js/Components/BackButton'))
Vue.component('postcode-modal', () => import(/* webpackChunkName: "postcode-modal" */ '@modulesPages/Site/Resources/assets/js/Components/PostcodeModal'))
Vue.component('floating-whatsapp', () => import(/* webpackChunkName: "floating-whatsapp" */ '@modulesPages/Site/Resources/assets/js/Components/FloatingWhatsapp'))

Vue.component('gallery', () => import(/* webpackChunkName: "gallery" */ '@modulesPages/Site/Resources/assets/js/Gallery/Gallery'))
Vue.component('gallery-item', () => import(/* webpackChunkName: "gallery-item" */ '@modulesPages/Site/Resources/assets/js/Gallery/GalleryItem'))
Vue.component('zoom', () => import(/* webpackChunkName: "zoom" */ '@modulesPages/Site/Resources/assets/js/Gallery/Zoom'))



if(app.$state.scope == 'web') {
	app.$set(app.$state, 'site', {
		showModalFilters: false,
		productFilters: {},
		addressModal: false
	})
}

app.$set(app.$state, 'authImg', null)
app.$set(app.$state, 'guarantee', null)
